// src/pages/AdminPage.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useSettings } from '../hooks/useSettings';

const TIPI = [
  { key: 'bollo',          label: 'Bollo',                sub: 'Tassa di proprietà annuale' },
  { key: 'assicurazione',  label: 'Assicurazione RC',     sub: 'Polizza e garanzie aggiuntive' },
  { key: 'collaudo',       label: 'Collaudo / Revisione', sub: 'Revisione biennale' },
  { key: 'messa_in_moto',  label: 'Messa in moto',        sub: 'Promemoria stagionale' },
  { key: 'certificazione', label: 'Certificazione',       sub: 'ASI / FMI / CRS' },
];

const RECURRENCES = [
  { value: '6m', label: '6 mesi' },
  { value: '1y', label: '1 anno' },
  { value: '2y', label: '2 anni' },
  { value: '3y', label: '3 anni' },
  { value: 'free', label: 'Data libera' },
];

export default function AdminPage() {
  const { isAdmin }              = useAuth();
  const { settings, updateSettings } = useSettings();
  const navigate                 = useNavigate();
  const [local,   setLocal]      = useState(null);
  const [saved,   setSaved]      = useState(false);
  const [saving,  setSaving]     = useState(false);

  useEffect(() => {
    if (settings) setLocal(JSON.parse(JSON.stringify(settings)));
  }, [settings]);

  if (!isAdmin) return <div style={S.page}><p style={{padding:40,color:'#c62828'}}>Accesso non autorizzato.</p></div>;
  if (!local)   return <div style={S.page}><p style={{padding:40,color:'#888'}}>Carico impostazioni…</p></div>;

  const setTipo = (key, field, val) => {
    setLocal(s => ({ ...s, tipi: { ...s.tipi, [key]: { ...s.tipi[key], [field]: val } } }));
  };
  const setNotif = (field, val) => {
    setLocal(s => ({ ...s, notifiche: { ...s.notifiche, [field]: val } }));
  };
  const setPerm = (field, val) => {
    setLocal(s => ({ ...s, permessi: { ...s.permessi, [field]: val } }));
  };

  const save = async () => {
    setSaving(true);
    await updateSettings(local);
    setSaving(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  return (
    <div style={S.page}>
      <div style={S.topbar}>
        <span style={S.back} onClick={() => navigate('/')}>← Dashboard</span>
        <h1 style={S.title}>Pannello di controllo</h1>
        <span style={S.adminBadge}>Admin</span>
      </div>

      <div style={S.content}>

        {/* TIPI SCADENZA */}
        <Section title="Tipi di scadenza — abilita / disabilita">
          {TIPI.map(t => (
            <Row key={t.key} label={t.label} sub={t.sub}>
              <select
                style={S.select}
                value={local.tipi?.[t.key]?.ricorrenzaDefault || '1y'}
                onChange={e => setTipo(t.key, 'ricorrenzaDefault', e.target.value)}
              >
                {RECURRENCES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
              </select>
              <Toggle
                checked={local.tipi?.[t.key]?.attivo !== false}
                onChange={v => setTipo(t.key, 'attivo', v)}
              />
            </Row>
          ))}
        </Section>

        {/* NOTIFICHE */}
        <Section title="Notifiche — anticipo e canali">
          <Row label="Primo avviso" sub="Giorni prima della scadenza">
            <NumInput
              value={local.notifiche?.anticipo1 ?? 30}
              onChange={v => setNotif('anticipo1', v)}
            /> <span style={S.unit}>giorni</span>
          </Row>
          <Row label="Promemoria" sub="Secondo avviso ravvicinato">
            <NumInput
              value={local.notifiche?.anticipo2 ?? 7}
              onChange={v => setNotif('anticipo2', v)}
            /> <span style={S.unit}>giorni</span>
          </Row>
          <Row label="Avviso urgente" sub="Ultimo avviso critico">
            <NumInput
              value={local.notifiche?.anticipo3 ?? 1}
              onChange={v => setNotif('anticipo3', v)}
            /> <span style={S.unit}>giorni</span>
          </Row>
          <Row label="Email" sub="Inviata a ogni proprietario">
            <Toggle checked={local.notifiche?.email !== false} onChange={v => setNotif('email', v)} />
          </Row>
          <Row label="Banner in-app" sub="All'apertura dell'app">
            <Toggle checked={local.notifiche?.inApp !== false} onChange={v => setNotif('inApp', v)} />
          </Row>
          <Row label="Push mobile" sub="Notifica diretta sul telefono">
            <Toggle checked={!!local.notifiche?.push} onChange={v => setNotif('push', v)} />
          </Row>
        </Section>

        {/* PERMESSI */}
        <Section title="Permessi utenti">
          <Row label="Utenti modificano scadenze" sub="Se no: solo lettura per tutti">
            <Toggle checked={local.permessi?.utentiModificanoScadenze !== false} onChange={v => setPerm('utentiModificanoScadenze', v)} />
          </Row>
          <Row label="Utenti aggiungono veicoli" sub="Se no: solo admin può aggiungere">
            <Toggle checked={!!local.permessi?.utentiAggiunganoVeicoli} onChange={v => setPerm('utentiAggiunganoVeicoli', v)} />
          </Row>
          <Row label="Utenti vedono veicoli altrui" sub="Se no: visione solo propria">
            <Toggle checked={!!local.permessi?.utentiVedonoAltri} onChange={v => setPerm('utentiVedonoAltri', v)} />
          </Row>
        </Section>

        {/* SAVE */}
        <div style={S.saveRow}>
          {saved && <span style={S.savedMsg}>✓ Impostazioni salvate</span>}
          <button style={{ ...S.saveBtn, opacity: saving ? .6 : 1 }} onClick={save} disabled={saving}>
            {saving ? 'Salvo…' : 'Salva impostazioni'}
          </button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={S.section}>
      <div style={S.secTitle}>{title}</div>
      {children}
    </div>
  );
}

function Row({ label, sub, children }) {
  return (
    <div style={S.row}>
      <div>
        <div style={S.rowLabel}>{label}</div>
        {sub && <div style={S.rowSub}>{sub}</div>}
      </div>
      <div style={S.rowControls}>{children}</div>
    </div>
  );
}

function Toggle({ checked, onChange }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
      <div
        style={{ ...S.toggleTrack, background: checked ? '#1a1a1a' : '#e0e0e0' }}
        onClick={() => onChange(!checked)}
      >
        <div style={{ ...S.toggleThumb, transform: checked ? 'translateX(20px)' : 'none' }} />
      </div>
      <span style={{ ...S.toggleLabel, color: checked ? '#2e7d32' : '#bbb' }}>
        {checked ? 'Attivo' : 'Disattivo'}
      </span>
    </div>
  );
}

function NumInput({ value, onChange }) {
  return (
    <input
      type="number"
      style={S.numInput}
      value={value}
      min={1}
      onChange={e => onChange(parseInt(e.target.value, 10))}
    />
  );
}

const S = {
  page:    { minHeight:'100vh', background:'#f5f4f0', fontFamily:"'Georgia', serif" },
  topbar:  { display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 20px', background:'#fff', borderBottom:'1px solid #e8e8e8' },
  back:    { fontSize:15, cursor:'pointer', color:'#185FA5' },
  title:   { fontSize:18, fontWeight:600 },
  adminBadge: { fontSize:13, padding:'4px 12px', borderRadius:20, background:'#ffebee', color:'#c62828', fontWeight:600 },
  content: { padding:20, maxWidth:680, margin:'0 auto' },
  section: { background:'#fff', borderRadius:14, padding:'20px 22px', marginBottom:16, border:'1px solid #e8e8e8' },
  secTitle:{ fontSize:14, fontWeight:600, color:'#888', marginBottom:16, textTransform:'uppercase', letterSpacing:'.6px' },
  row:     { display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 0', borderBottom:'1px solid #f5f5f5' },
  rowLabel:{ fontSize:15, fontWeight:500, color:'#1a1a1a' },
  rowSub:  { fontSize:13, color:'#aaa', marginTop:2 },
  rowControls: { display:'flex', alignItems:'center', gap:10 },
  select:  { border:'1px solid #e0e0e0', borderRadius:8, padding:'6px 10px', fontSize:14, background:'#fafafa', color:'#1a1a1a', fontFamily:'inherit', cursor:'pointer', minWidth:120 },
  toggleTrack: { position:'relative', width:44, height:24, borderRadius:12, cursor:'pointer', transition:'background .2s' },
  toggleThumb: { position:'absolute', top:3, left:3, width:18, height:18, borderRadius:'50%', background:'#fff', transition:'transform .2s', boxShadow:'0 1px 3px rgba(0,0,0,.2)' },
  toggleLabel: { fontSize:13, fontWeight:500 },
  numInput:{ border:'1px solid #e0e0e0', borderRadius:8, padding:'6px 10px', fontSize:15, width:64, textAlign:'center', fontFamily:'inherit', background:'#fafafa' },
  unit:    { fontSize:14, color:'#888' },
  saveRow: { display:'flex', alignItems:'center', justifyContent:'flex-end', gap:16, marginTop:8 },
  savedMsg:{ fontSize:14, color:'#2e7d32', fontWeight:500 },
  saveBtn: { padding:'12px 28px', borderRadius:10, border:'none', background:'#1a1a1a', color:'#fff', fontSize:16, fontWeight:600, cursor:'pointer', fontFamily:'inherit' },
};
